/**
 * Checks whether or not the given array contains the same elements,
 * regardless of the order.
 * @param  {Array}  arr1
 * @param  {Array}  arr2
 * @returns {Boolean}
 */
function isEqualContentArrayUtil (arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  return arr1.every(elem => arr2.includes(elem))
}

export {
  isEqualContentArrayUtil
}
